import { render, staticRenderFns } from "./CustomerOilStorageDetail.vue?vue&type=template&id=1591d94c&scoped=true"
import script from "./CustomerOilStorageDetail.vue?vue&type=script&lang=js"
export * from "./CustomerOilStorageDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerOilStorageDetail.vue?vue&type=style&index=0&id=1591d94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591d94c",
  null
  
)

export default component.exports